import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = [
    "form",
    "filtersContainer",
    "filterTemplate",
    "previewButton",
    "previewPending",
  ];
  static values = {
    index: Number,
    dirty: { type: Boolean, default: false },
    filterFieldsUrl: String,
    previewUrl: String,
  };

  markDirty() {
    this.dirtyValue = true;
    this.dispatch("dirty");
  }

  addFilter(event) {
    event.preventDefault();

    const content = this.filterTemplateTarget.innerHTML.replace(/NEW_RECORD/g, this.indexValue);
    this.filtersContainerTarget.insertAdjacentHTML("beforeend", content);
    this.indexValue++;
    this.markDirty();
  }

  removeFilter(event) {
    event.preventDefault();

    const filterItem = event.target.closest("[data-filter-item]");
    if (!filterItem) return;

    const destroyInput = filterItem.querySelector('input[name*="[_destroy]"]');

    if (destroyInput) {
      destroyInput.value = "1";
      filterItem.style.display = "none";
    } else {
      filterItem.remove();
    }

    this.markDirty();
  }

  propertyChanged(event) {
    const property = event.target.value;
    const filterItem = event.target.closest("[data-filter-item]");
    if (!filterItem || !property) return;

    const frame = filterItem.querySelector("turbo-frame[data-filter-fields]");
    if (!frame) return;

    const template = filterItem.querySelector("template[data-loading-template]");
    if (template) {
      frame.innerHTML = "";
      frame.appendChild(template.content.cloneNode(true));
    }

    const nameMatch = event.target.name.match(/\[(\d+)\]/);
    const index = nameMatch ? nameMatch[1] : "0";

    frame.src = `${this.filterFieldsUrlValue}?property=${encodeURIComponent(property)}&index=${index}`;
  }

  submitForm() {
    this.dirtyValue = false;
    this.dispatch("clean");
  }

  // Submit the preview request ourselves (not via Turbo) so we own the button
  // state end-to-end. A 2xx response means the preview is pending and the
  // broadcast will reset the button via previewPendingTargetDisconnected;
  // a 4xx response means an inline error was rendered — reset the button now.
  async submitPreview(event) {
    event.preventDefault();
    this.setPreviewButtonLoading(true);
    const response = await post(this.previewUrlValue, {
      body: new FormData(this.formTarget),
      responseKind: "turbo-stream",
    });
    if (!response.ok) this.setPreviewButtonLoading(false);
  }

  previewPendingTargetDisconnected() {
    this.setPreviewButtonLoading(false);
  }

  setPreviewButtonLoading(loading) {
    if (!this.hasPreviewButtonTarget) return;
    this.previewButtonTarget.disabled = loading;
    this.previewButtonTarget.textContent = loading ? "Loading…" : "Refresh Preview";
  }
}
